import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfig } from '../app.config';
import { throwError } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';
import { HelpersService } from './helpers.service';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback
 
@Injectable({
  providedIn: 'root',
})
export class ServiceTypeService {
  private env: any;

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService,
    private httpClient: HttpClient, 
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) {
    this.env = this.appConfig.getEnvironmentNew();
  }

  getServiceTypeMessageTemplates(partnerID, serviceTypeID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/Partner/${partnerID}/ServiceTypeMessageTemplates/${serviceTypeID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateServiceTypeMessageTemplates(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
          `/Partner/ServiceTypeMessageTemplate?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getWorkshopCustomQuestions(partnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/Workshop/${partnerID}/Configuration/CustomQuestions?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: Response) => {
          return throwError(res.json());
        }),
      );
  }

  getServiceTypesCustomQuestions(partnerID, serviceTypeIDs) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/Workshop/${partnerID}/ServiceTypes/CustomQuestions?code=${this.env.key}&serviceTypeIDs=${serviceTypeIDs}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: Response) => {
          return throwError(res.json());
        }),
      );
  }

  deleteWorkshopCustomQuestion(partnerID, customQuestionID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .delete(
        this.env.url +
          `/Workshop/${partnerID}/CustomQuestion/${customQuestionID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: Response) => {
          return throwError(res.json());
        }),
      );
  }

  getWorkshopServiceTypes(partnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/Workshop/${partnerID}/Configuration/ServiceTypes?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: Response) => {
          return throwError(res.json());
        }),
      );
  }

  updateWorkshopCustomQuestion(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
          `/Workshop/Configuration/CustomQuestions?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: Response) => {
          return throwError(res.json());
        }),
      );
  }

  bulkDeleteServiceTypes(partnerID : number, data : any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http.post(this.env.url +
          `/Partner/${partnerID}/BulkDelete/ServiceTypes?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),catchError((res: Response) => {
          return throwError(res.json());
        }),
      );
  }

  bulkCopyServiceTypes(partnerID : number, data : any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http.post(this.env.url +
          `/Partner/${partnerID}/BulkCopy/ServiceTypes?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),catchError((res: Response) => {
          return throwError(res.json());
        }),
      );
  }
  
  getPartnerServiceTypeWithLinkedSKUs(partnerID : number) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http.get(this.env.url +
        `/Partner/${partnerID}/ServiceTypes/LinkSKUs?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),catchError((res: Response) => {
          return throwError(res.json());
        }),
      );
  }

    
  getPartnerProductSKUsWithLinkedServices(partnerID : number) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http.get(this.env.url +
        `/Partner/${partnerID}/ProductSKUs/LinkedServiceTypes?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),catchError((res: Response) => {
          return throwError(res.json());
        }),
      );
  }
}
